import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Link from "gatsby-link";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Seo from "../components/Seo";
import Footer from "../components/Footer";

const styles = theme => ({});

const TopThree = () => {
  const data = {
    frontmatter: {
      title: "Best surf helmets",
      description:
        "The top 3 best surf helmets currently available, considering impact protection and surfing performance.  All helmets tried and tested.  All applicable helmet technologies researched and referenced.  There's no better resource on the internet comparing what's available now and what could be, gauranteed.  If you're looking for the right surf helmet, you've found the right place."
    }
  };
  const facebook = {};
  return (
    <Main>
      <Article>
        <PageHeader title="Best surf helmets" subTitle="The top 3 and runner-ups in 2026" />
        <Content>
          <h3>Manera S-Foam Surf Helmet: The best small wave helmet</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/PXL_20260601_190642144.PORTRAIT-EDIT_i6skuo.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Looks like a squid lid</td>
              <td>Slides back due to bucket effect</td>
            </tr>
            <tr>
              <td>Non-newtonian fluid foam protection</td>
              <td>No sun protection</td>
            </tr>
            <tr>
              <td>Light, thin profile</td>
              <td>Not enough size options</td>
            </tr>
            <tr>
              <td>Deflects water from eyes</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: The Manera S-Foam Surf Helmet looks great, and provides
          good protection thanks to its non-newtonian fluid foam liner. It is my new top choice for
          small waves in 2026. <Link to="/reviews/manera-s-foam-helmet/">Full review</Link>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://backcountry.tnu8.net/7XoPE5"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Backcountry.com price
              </a>
              <a
                href="https://amzn.to/3PWqF3U"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Oakley WTR Icon Surf Helmet: The best big wave helmet</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/PXL_20260601_191256018.PORTRAIT_ppezeh.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Designed for surfing</td>
              <td>Slides back unless fit dial is set crazy tight</td>
            </tr>
            <tr>
              <td>Highly protective EPP liner</td>
              <td>Hard to achieve ideal fit</td>
            </tr>
            <tr>
              <td>Plenty of holes for water to flow through</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Fastening fit dial</td>
              <td>Big gaps in the liner</td>
            </tr>
            <tr>
              <td>
                4-star white water rated by{" "}
                <a
                  href="https://www.helmet.beam.vt.edu/whitewater-helmet-ratings.html"
                  target="_blank"
                >
                  Virginia Tech’s Helmet Lab
                </a>
              </td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: The Oakley WTR Icon Helmet performs well thanks to its
          fit dial, and protects even better. It's the first ever hard shell helmet designed for
          surfing - with a highly protective EPP liner like many bike and snow helmets to boot. It's
          my go-to helmet when the waves get big.{" "}
          <Link to="/reviews/oakley-wtr-icon-helmet/">Full review</Link>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.oakley.com/en-us/product/FOS901786"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.cleanlinesurf.com/products/oakley-wtr-icon-surf-helmet-fos901786"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Cleanline Surf price
              </a>
            </div>
          </div>
          <h3>Gamebreaker-PRO with D3O: The best all around</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/IMG_20190711_181020_fj5zeu.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Light, minimal</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Stays on your head</td>
              <td>Takes on a tad bit of water</td>
            </tr>
            <tr>
              <td>
                5-star protection according to{" "}
                <a href="https://helmet.beam.vt.edu/soccer-headgear-ratings.html" target="_blank">
                  Virginia Tech’s Helmet Lab
                </a>
              </td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: Good performance and protection. My top recommendation
          currently on the market. A recent study shows it{" "}
          <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33981403/">
            outperforms
          </a>{" "}
          other soft-shell helmets. <Link to="/reviews/gamebreaker-pro-d3o/">Full review</Link>
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gamebreaker.com/shop/gamebreaker-pro-soft-shell-sports-helmet"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2ZGAgAn"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>1st Runner-up</h2>
          <h3>Olaian Surf Helmet: Still a good small wave option</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230710_184716_2_zg4xvx.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Surfer look</td>
              <td>Slides back due to bucket effect</td>
            </tr>
            <tr>
              <td>PU Foam</td>
              <td>No sun protection</td>
            </tr>
            <tr>
              <td>Light, minimal, comfortable</td>
              <td />
            </tr>
            <tr>
              <td>Deflects water from eyes</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: While the new Olaian Surf Helmet by Decathlon looks good
          and provides adequate protection, Decathlon has made a couple of design choices that
          prevent it from performing exceptionally. However, despite its faults, it is still a great
          option. <Link to="/reviews/olaian-surf-helmet/">Full review</Link>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.decathlon.com/collections/surf-accessories-spare-parts/products/decathlon-water-sports-surfing-wake-foiling-kitesurfing-paddling-helmet-327505?"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Only available directly from Decathlon
              </a>
            </div>
          </div>
          <h2>2nd Runner-up</h2>
          <h3>Ride Engine Barrier Soft Helmet</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20220530_173042_nyxuar.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Fits like a glove</td>
              <td>Thin layers of EVA</td>
            </tr>
            <tr>
              <td>Very light</td>
              <td>No ear protection</td>
            </tr>
            <tr>
              <td>Sun protection</td>
              <td />
            </tr>
          </table>
          <strong>Recommendation</strong>: A kitesurfing impact hat that also works very well for
          surfing, the Ride Engine Barrier Soft Helmet is super comfortable, and protects you from
          the sun. Unfortunately, for impact protection, all it offers is two thin layers of
          dual-density EVA. The lack of good protection though can easily be remedied by adding your
          own liner (check my <Link to="/discreet/">discreet page</Link> for ideas - I used the
          Gamebreaker Stealth Helmet Liner, and cut it to shape). However, after much use, the
          stretchy, strap mechanism gets worn out, and it no longer stays on while getting pounded.
          Perhaps try replacing it with a buckle based strap.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://rideengine.com/products/barrier-soft-helmet"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/3HzMGwO"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>3rd Runner-up</h2>
          <h3>DMC Soft Surf Helmet (&V2)</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/dmc_cover_ubjoxe.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Designed for surfing</td>
              <td>Water drips in eyes</td>
            </tr>
            <tr>
              <td>Extremely light</td>
              <td>Loose fitting</td>
            </tr>
            <tr>
              <td>Neck sun protection</td>
              <td>Awkward, lace-up back</td>
            </tr>
          </table>
          <strong>Recommendation</strong>: No different from the{" "}
          <a
            target="_blank"
            href="https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325"
          >
            new V2 version
          </a>, the DMC Soft Surf Helmet offers low to moderate protection for any size wave. Decent
          coverage, despite the gaps, and neck sun protection too. Insanely light, but it's so light
          it's hard to achieve a decent fit. Because of this it's impossible to avoid water dripping
          in your eyes. However, it works well over wetsuit hoods. The low levels of protection can
          of course also be easily remedied by adding your own liner (check my{" "}
          <Link to="/discreet/">discreet page</Link> for ideas).{" "}
          <Link to="/reviews/dmc-soft-surf-helmet/">Full review</Link>
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://dmcfins.com/collections/accessories/products/dmc-soft-surf-helmet-v2-black?variant=40966619627717"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h2>4th runner up</h2>
          <h3>Gath Surf Convertible: Still deserves a spot, but needs thicker EVA</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/IMG_20190711_181328_byo5qh.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <table>
            <tr>
              <th>Pros</th>
              <th>Cons</th>
            </tr>
            <tr>
              <td>Made for surfing</td>
              <td>Thin layer of EVA = minimal protection</td>
            </tr>
            <tr>
              <td>Stays on your head with ear covers</td>
              <td>Even less protection in multiple impacts</td>
            </tr>
            <tr>
              <td>Low friction, ABS shell</td>
              <td>Experienced bucket effect without ear covers</td>
            </tr>
          </table>
          <strong>Recommendation</strong>: Wouldn't recommend it due to it's thin layer of EVA
          (although I would recommend the{" "}
          <a
            target="_blank"
            href="https://www.amazon.com/Gath-Gedi-Helmet-Peak-Black/dp/B00ITT6TV8?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=ce7fb36a82fe938ab11a8ae137d27c4e&camp=1789&creative=9325"
          >
            Gath Gedi
          </a>). If you can't achieve a better fit with anything else though, it does perform well.
          Therefore, it's usable - just replace it often. To read why I wouldn't trust such a thin
          layer of EVA foam to protect your brain read the{" "}
          <Link to="/reviews/gath-surf-converible/">full review</Link>. For a little bit better
          protection try the{" "}
          <a href="https://amzn.to/2OfDHqI" target="_blank">
            Gath Gedi
          </a>.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gathsports.com/gath-sports-shop/gath-sfc/"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/2QldqtW"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
        </Content>
        <p style={{ lineHeight: "1.5rem", margin: "40px 0" }}>
          Ever wonder how to prevent your lips from getting sunburned? Just so happens that I
          started wondering that a couple years and started experimenting. Check out my new page on{" "}
          <Link to="/lip-sun-protection/">top lip balm sunscreens</Link>.
        </p>
      </Article>
      <Footer footnote={data} />
      <Seo data={data} facebook={facebook} page />
    </Main>
  );
};

TopThree.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(TopThree);



// WEBPACK FOOTER //
// ./src/pages/top-3.js